import { LegendContinuous } from './legendContinuous';
export var LegendContinuousBlock = function LegendContinuousBlock(options) {
  return function () {
    return LegendContinuous(Object.assign({}, {
      block: true
    }, options)).apply(void 0, arguments);
  };
};
LegendContinuousBlock.props = Object.assign(Object.assign({}, LegendContinuous.props), {
  defaultPosition: 'top',
  defaultOrientation: 'horizontal'
});